<ig-card class="place-card" tabindex="0" (keypress)="enterItemByKeyboard($event)" [picture]="place.cover?.source"
    [placeCategoryList]="place.categoryList" [isPromotionImage]="place.isPromotionImage" [containTitle]="true"
    [ngClass]="{'pinned':place.pinnedTime}" [alt]="place.title||place.name" (click)="showDetails()">

    <div title>
        @{{place.name||place.title}}
    </div>

    <div detail *ngIf="!place.isPromotionImage">
        <div class="detail"><mat-icon>room</mat-icon>{{place.address?.address||'(no location)'}}</div>
        <div class="detail" *ngIf="place.socialName==='facebook'"><mat-icon>thumb_up</mat-icon><span
                *ngIf="place.likes">{{place.likes}} Likes /</span>{{place.checkins}} Checkins</div>
        <div class="detail" *ngIf="place.socialName==='google'"><mat-icon>thumb_up</mat-icon>Rating: {{place.rating}} /
            User Ratings Total: {{place.user_ratings_total}}</div>
        <div class="detail"><mat-icon>list</mat-icon>{{showReadable(place.category)}}</div>

        <div class="details">
            <span class="editor-choice" *ngIf="place.isChoice">
                <!--TODO: add a settings for custom editor's choice tip-->
                <mat-icon>favorite_border</mat-icon>
                {{editorChoiceText}}
            </span>
            <ig-button (trigger)="showDetails()">DETAILS</ig-button>
        </div>
    </div>
</ig-card>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/calendar/place.card/visitor.place.card.component.html